import AuthLayout from "../../../components/layouts/auth";
import { useState } from "react";
import MarketingCampaignForm from "./form";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

const CreateMarketing = () => {
  return (
    <AuthLayout>
      <div>
        <Link to={"/marketing"} className="btn btn-primary"></Link>
        <h2 className="text-[#8D8D8D] font-[600] text-[14px]">
          Marketing Campaign / create
        </h2>
        <div className="flex items-center pl-0 mt-4 mb-5 space-x-2">
          <span>
            <Link to={"/marketing"}>
              <ChevronLeft size={20} className="-ml-2" />
            </Link>
          </span>
          <h1 className="font-[600] text-tertiary text-[18px]">
            Marketing Campaign / Create
          </h1>
        </div>
        <MarketingCampaignForm />
      </div>
    </AuthLayout>
  );
};

export default CreateMarketing;
